<template>
  <div id="creation-section-wrapper">
    <h3 class="creation-section-title txt-bold">Creación</h3>

    <div class="creation-gohome-container">
      <button
        class="creation-gohome-btn txt-grad-color-2 txt-bold"
        @click="goHome"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="currentColor"
          class="bi bi-arrow-left"
          viewBox="0 0 16 16"
        >
          <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop
              offset="0%"
              style="stop-color: rgb(0, 246, 187); stop-opacity: 1"
            />
            <stop
              offset="100%"
              style="stop-color: rgb(29, 143, 206); stop-opacity: 1"
            />
          </linearGradient>
          <path
            fill="url(#grad2)"
            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
          />
        </svg>
        Volver al inicio
      </button>
    </div>
    <form class="creation-general-form" @submit.prevent>
      <!-- Bloque 1 Nombre de la plantilla-->
      <div class="creation-name-step-wrapper" v-if="step === 1">
        <p class="creation-name-title">
          Hola <span class="txt-bold">{{ nombreUsuario }}</span
          >.
        </p>
        <p class="creation-name-txt">
          <span class="txt-bold">Personaliza tu plantilla</span> de
          valoraciones.
        </p>
        <label class="creation-name-label txt-bold" for="creation-name"
          >Nombre de Plantilla:
          <input
            type="text"
            class="creation-name-input"
            :class="{ 'creation-invalid-input': errors.nameError }"
            id="creation-name"
            v-model="formPlantilla.nombre_plantilla"
            ref="creationName"
            @keyup.enter="handleNextStep"
          />
          <p class="creation-invalid-feedback">{{ errors.nameFeedback }}</p>
        </label>
        <button type="button" class="creation-grad-btn" @click="handleNextStep">
          <span class="txt-bold">Siguiente</span>
        </button>
        <button
          type="button"
          class="creation-normal-btn txt-bold"
          @click="goHome"
        >
          Atrás
        </button>
      </div>
      <!-- Bloque 2 Cantidad de Momentos-->
      <div class="creation-moments-step-wrapper" v-if="step === 2">
        <p class="creation-name-title"><span class="txt-bold">Ahora,</span></p>
        <p class="creation-name-txt">
          Por favor digita la cantidad de
          <span class="txt-bold">MOMENTOS</span> que desea evaluar.
        </p>
        <input
          type="number"
          class="creation-moments-input"
          :class="{ 'creation-invalid-input': errors.momentsError }"
          id="creation-moments"
          v-model="formPlantilla.numero_d_momentos"
          ref="creationMoments"
          @keyup.enter="handleNextStep"
        />
        <p class="creation-invalid-feedback mb-4 txt-bold">
          {{ errors.momentsFeedback }}
        </p>
        <button type="button" class="creation-grad-btn" @click="handleNextStep">
          <span class="txt-bold">Siguiente</span>
        </button>
        <button
          type="button"
          class="creation-normal-btn txt-bold"
          @click="handlePrevStep"
        >
          Atrás
        </button>
      </div>
      <!-- Bloque 3-->
      <div class="creation-weights-step-wrapper" v-if="step === 3">
        <p class="creation-name-txt">
          Por favor digita el <span class="txt-bold">peso</span> de cada uno de
          los momentos de aprendizaje.
        </p>
        <!-- 
                <div class="creation-weights-percent-mobile-container">
                    <label class="creation-weights-percent-label" for="creation-weights-percent">
                        <span class="txt-grad-azul txt-bold">% Disponible</span>
                        <input type="text" name="creation-weights-percent" id="creation-weights-percent" v-model="percentageLeft" readonly />
                    </label>
                </div>
                -->
        <div class="creation-weights-input-wrapper">
          <label
            class="creation-weights-label"
            :for="`creation-weight-${index}`"
            v-for="(moment, index) in intMomentos"
            :key="moment"
          >
            <input
              type="text"
              class="creation-weights-moment-input txt-grad-azul txt-bold"
              :id="`nom-moment` + index"
              v-model="formPlantilla.arrayMomentos[index]"
            />
            <!-- <span class="creation-weights-label-title txt-grad-azul txt-bold">Momento {{ moment }}</span> -->
            Peso #{{ moment }}
            <input
              type="number"
              :id="`creation-weight-${index}`"
              class="creation-weights-input"
              :class="{ 'creation-invalid-input': errors.percentageError }"
              v-model="formPlantilla.arrayPorcentajes[index]"
              @keyup="validatePercentage($event)"
            />
          </label>
        </div>
        <p class="creation-invalid-feedback txt-bold">
          {{ errors.percentageFeedback }}
        </p>
        <div class="creation-weights-percent-container">
          <label
            class="creation-weights-percent-label"
            for="creation-weights-percent"
          >
            <span class="txt-grad-azul txt-bold">% Disponible</span>
            <input
              type="text"
              class="txt-bold"
              id="creation-weights-percent"
              name="creation-weights-percent"
              v-model="percentageLeft"
              readonly
            />
          </label>
        </div>
        <div class="creation-weights-footer">
          <button
            type="button"
            class="creation-grad-btn d-none"
            id="btnMomentos"
            @click="getInsPlantilla"
            :disabled="saving"
          >
            <span class="txt-bold">
              <div class="lds-ring" v-if="saving">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              {{ saving ? "Guardando..." : "Guardar" }}</span
            >
          </button>
          <button
            type="button"
            class="creation-normal-btn txt-bold"
            @click="handlePrevStep"
          >
            Atrás
          </button>
        </div>
      </div>
    </form>
    <b-modal
      v-model="modal.show"
      id="creation-modal"
      centered
      :title="modal.title"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="creation-modal-body">
        <p class="creation-modal-txt" v-html="modal.text"></p>
      </div>
      <template #modal-footer>
        <button
          type="button"
          class="creation-modal-normal-btn txt-bold"
          @click="goHome"
        >
          {{ modal.normalBtnText }}
        </button>
        <button
          type="button"
          class="creation-modal-grad-btn"
          @click="getEvaluationSection"
        >
          <span class="txt-bold">{{ modal.gradBtnText }}</span>
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import MEC_Plantillas_api from "@/modules/MEC_Plantillas_api";
import MEC_Momentos_api from "@/modules/MEC_Momentos_api";

//@Hace referencia a toda la funcionalidad de vue, metodos y variables
var varSelf = null;

export default {
  data() {
    return {
      step: 1,
      saving: false,
      formPlantilla: {
        id_plantilla: 0,
        nombre_plantilla: "",
        numero_d_momentos: null,
        //id_funcionario: 369, // session
        Id_institucion: 1, //por el es predeterminado
        arrayMomentos: [],
        arrayPorcentajes: [],
        habilitado: 1,
      },
      errors: {
        nameFeedback: "",
        nameError: false,
        momentsFeedback: "",
        momentsError: false,
        percentageFeedback: "",
        percentageError: false,
      },
      modal: {
        show: false,
        title: "",
        text: "",
        normalBtnText: "",
        gradBtnText: "",
      },
    };
  },

  props: ["id_funcionario", "nombreUsuario"],

  computed: {
    intMomentos() {
      return Number(this.formPlantilla.numero_d_momentos);
    },
    percentageLeft() {
      let percentageUsed = 0;

      if (this.formPlantilla.arrayPorcentajes.length > 0) {
        percentageUsed = this.formPlantilla.arrayPorcentajes.reduce(
          (acumulado, valorActual) => {
            return Number(acumulado) + Number(valorActual);
          }
        );
      }
      return 100 - percentageUsed;
    },
  },

  watch: {
    intMomentos() {
      for (let i = 0; i < this.intMomentos; i++) {
        this.formPlantilla.arrayMomentos[i] = `Momento ${i + 1}`;
      }
    },
  },
  created() {
    varSelf = this;
  },

  methods: {
    handleCreationSubmit() {
      //if (this.validatePercentage()) {
      this.saving = false;
      this.modal.title = "Guardado exitosamente";
      this.modal.text =
        "La plantilla ha sido guardada exitosamente, ¿Deseas <span class='txt-grad-color-2 txt-bold'>evaluar</span> con esta plantilla o  <span class='txt-bold'>salir</span> al inicio de la aplicación?";
      this.modal.normalBtnText = "Salir";
      this.modal.gradBtnText = "Evaluar";
      this.modal.show = true;
      //}
    },
    handleNextStep() {
      switch (this.step) {
        case 1:
          this.validateName();
          break;
        case 2:
          this.validateMoments();
          break;
        default:
          break;
      }
    },
    handlePrevStep() {
      this.formPlantilla.arrayPorcentajes = [];
      this.step--;
    },
    validateName() {
      this.formPlantilla.nombre_plantilla =
        this.formPlantilla.nombre_plantilla.trim();

      if (!this.formPlantilla.nombre_plantilla) {
        this.focusInput("creationName");
        this.errors.nameFeedback = "Debes digitar un nombre para tu plantilla";
        this.errors.nameError = true;
      } else {
        this.errors.nameFeedback = "";
        this.errors.nameError = false;
        this.step++;
      }
    },
    validateMoments() {
      // const numberDecimalRe = /^\d*\.?\d*$/;
      const numberRe = /^\d+$/;
      this.formPlantilla.numero_d_momentos =
        this.formPlantilla.numero_d_momentos.trim();

      if (!this.formPlantilla.numero_d_momentos) {
        this.focusInput("creationMoments");
        this.errors.momentsFeedback =
          "Debes digitar la cantidad de momentos a evaluar";
        this.errors.momentsError = true;
      } else if (!numberRe.test(this.formPlantilla.numero_d_momentos)) {
        this.focusInput("creationMoments");
        this.errors.momentsFeedback =
          "Debes digitar un número entero válido entre 1 y 10";
        this.errors.momentsError = true;
      } else if (
        Number(this.formPlantilla.numero_d_momentos) <= 0 ||
        Number(this.formPlantilla.numero_d_momentos) > 10
      ) {
        this.focusInput("creationMoments");
        this.errors.momentsFeedback =
          "El número no puede ser mayor a 10 ni tampoco cero";
        this.errors.momentsError = true;
      } else {
        //@Guarda la plantilla
        //this.getInsPlantilla();
        this.errors.momentsFeedback = "";
        this.errors.momentsError = false;
        this.step++;
      }
    },
    validatePercentage() {
      var varBtnMomentos = document.getElementById("btnMomentos");
      if (this.percentageLeft !== 0.0) {
        this.errors.percentageFeedback =
          "El total de los momentos debe sumar 100% exacto";
        this.errors.percentageError = true;
        //@Oculta el boton de guardar
        varBtnMomentos.classList.add("d-none");

        return false;
      } else {
        this.errors.percentageFeedback = "";
        this.errors.percentageError = false;
        //@Habilita el boton de guardar
        varBtnMomentos.classList.remove("d-none");

        return true;
      }
      // console.log(event);
      // if (!Number(event.target.value)) {
      //   console.log("Entrada invalida");
      // }
    },
    focusInput(inputRef) {
      this.$nextTick(() => {
        this.$refs[inputRef].focus();
      });
    },
    getEvaluationSection() {
      this.$emit("getEvaluate", this.formPlantilla);
    },
    goHome() {
      this.$emit("sectionChange", { section: "home", lastSection: "creation" });
    },
    async getInsPlantilla() {
      var api = new MEC_Plantillas_api();
      this.formPlantilla.id_funcionario = this.id_funcionario;
      this.saving = true;

      if (varSelf.formPlantilla.id_plantilla == "") {
        await api
          .insert(this.formPlantilla)
          .then(function (prmRes) {
            return prmRes;
          })
          .then(function (prmData) {
            varSelf.formPlantilla.id_plantilla = prmData.data.id_plantilla;
            varSelf.getInsMomentos();
          });
      } else {
        await api
          .update(this.formPlantilla)
          .then(function (prmRes) {
            return prmRes;
          })
          .then(function (prmData) {
            varSelf.formPlantilla.id_plantilla = prmData.data.id_plantilla;
          });
      }

      this.saving = true;
    },
    async getInsMomentos() {
      var api = new MEC_Momentos_api();
      let response;
      var varFormMomentos = {};
      this.saving = true;

      for (var i = 0; i < this.intMomentos; i++) {
        varFormMomentos = {
          id_plantilla: varSelf.formPlantilla.id_plantilla,
          momento_nro: i + 1,
          nombre_momento: document.getElementById("nom-moment" + i).value,
          peso_momento: document.getElementById("creation-weight-" + i).value,
          habilitado: 1,
        };
        api
          .insert(varFormMomentos)
          .then(function (prmRes) {
            //varSelf.formPlantilla.arrayPorcentajes.push({nom_momento: document.getElementById("nom-moment"+i).value, peso_momento:document.getElementById("creation-weight-"+ i).value});

            return prmRes;
          })
          .then(function (prmData) {
            response = prmData;
            // console.log(prmData);
          });
      }
      this.saving = false;
      this.handleCreationSubmit();
      return response;
    },
  },
};
</script>

<style>
#creation-section-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.creation-section-title {
  font-size: 40px;
  color: var(--white);
  text-align: center;
}

.creation-gohome-container {
  width: 70%;
  margin: 50px auto 70px auto;
}

.creation-gohome-btn {
  all: unset;
  cursor: pointer;
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
}

.creation-gohome-btn::after {
  content: "";
  position: absolute;
  bottom: -5px;
  width: 0px;
  height: 2px;
  transition: width 0.1s linear;
  background-image: var(--grad-color-2);
  border-radius: 4px;
}

.creation-gohome-btn:focus::after {
  width: 100%;
}

.creation-gohome-btn svg {
  transition: transform 0.3s ease-in-out;
}

.creation-gohome-btn:hover svg {
  transform: translateX(-10px);
}

.creation-general-form {
  width: 80%;
  margin: 0 auto;
}

.creation-name-step-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.creation-name-title {
  margin: 0;
  color: var(--white);
  text-align: center;
  font-size: 25px;
}

.creation-name-txt {
  margin: 0;
  color: var(--white);
  text-align: center;
  font-size: 20px;
}

.creation-name-label {
  margin: 40px auto;
  display: flex;
  flex-direction: column;
  width: 90%;
  max-width: 300px;
  color: var(--white);
  gap: 0.5rem;
}

.creation-name-input {
  outline: none;
  width: 100%;
  height: 48px;
  padding: 0 10px;
  border-radius: 15px;
  border: double 1px transparent;
  border-radius: 10px;
  background-image: linear-gradient(white, white), var(--grad-color-2);
  background-origin: border-box;
  background-clip: padding-box, border-box;
}

.creation-grad-btn {
  margin: 0 auto;
  border: none;
  width: 150px;
  height: 48px;
  background-image: var(--grad-color-2);
  border-radius: 15px;
  padding: 2px;
}

.creation-grad-btn span {
  width: 100%;
  height: 100%;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  background-color: var(--black);
  color: var(--white);
  border-radius: 13px;
  transition: background 0.3s ease-in-out;
}

.creation-grad-btn:disabled {
  background-image: none;
  background-color: var(--input-border);
  cursor: not-allowed;
}

.creation-grad-btn:disabled span {
  color: var(--input-border);
}

.creation-grad-btn:disabled span .lds-ring div {
  border: 4px solid var(--input-border);
  border-color: var(--input-border) transparent transparent transparent;
}

.creation-grad-btn:hover span {
  background-color: transparent;
}

.creation-normal-btn {
  margin: 1rem auto;
  border: none;
  outline: none;
  background-color: transparent;
  color: var(--white);
  width: 150px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
}

.creation-grad-btn:focus,
.creation-normal-btn:focus {
  outline: 1px solid var(--white);
  outline-offset: 2px;
}

.creation-moments-step-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.creation-moments-input {
  outline: none;
  margin: 40px auto 10px auto;
  width: 48px;
  height: 48px;
  text-align: center;
  border-radius: 15px;
  border: double 1px transparent;
  border-radius: 10px;
  background-image: linear-gradient(white, white), var(--grad-color-2);
  background-origin: border-box;
  background-clip: padding-box, border-box;
}

.creation-weights-step-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.creation-weights-input-wrapper {
  margin: 80px auto;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 50px;
}

.creation-weights-moment-input {
  border: 1px solid var(--input-border);
  outline: none;
  width: auto;
  max-width: 150px;
  border-radius: 5px;
  caret-color: var(--white);
}

.creation-weights-label {
  flex-basis: 140px;
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: center;
  color: var(--white);
  align-items: center;
}

.creation-weights-input {
  outline: none;
  border: none;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background-color: var(--white);
  text-align: center;
}

.creation-name-input:focus,
.creation-moments-input:focus,
.creation-weights-input:focus {
  border: 1px solid var(--accent-color);
  box-shadow: 0 0 0.5rem 1px #49fffcbc;
}

.creation-weights-percent-container {
  margin-bottom: 1rem;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.creation-weights-percent-mobile-container {
  margin-top: 2rem;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  position: sticky;
  top: 0.5rem;
}

.creation-weights-percent-label {
  display: flex;
  gap: 20px;
  align-items: center;
}

.creation-weights-percent {
  outline: none;
  border: none;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background-color: var(--white);
  text-align: center;
}

#creation-weights-percent:read-only,
#creation-weights-percent[readonly] {
  outline: none;
  border: none;
  width: 55px;
  height: 48px;
  border-radius: 10px;
  text-align: center;
  background-image: var(--grad-color-azul);
}

.creation-weights-footer {
  display: flex;
  flex-direction: column;
}

.creation-invalid-feedback {
  margin: 0 auto;
  color: red;
  font-size: 14px;
  width: 100%;
  max-width: 300px;
  text-align: center;
}

.creation-invalid-input {
  border: 1px solid red;
}

.creation-invalid-input:focus {
  border: 1px solid red;
  box-shadow: 0 0 1rem 5px #ff5c5cbc;
}

/* ---------------------------------------------- Estilos modal creacion */
#creation-modal {
  font-family: var(--main-font);
}

#creation-modal + .modal-backdrop {
  background: rgba(0, 0, 0, 0.21);
  backdrop-filter: blur(7px);
}

#creation-modal .modal-content {
  background-color: var(--black);
  border: double 1px transparent;
  border-radius: 20px;
  background-image: linear-gradient(var(--black), var(--black)),
    var(--grad-color-2);
  background-origin: border-box;
  background-clip: padding-box, border-box;
}

#creation-modal .modal-header {
  border: none;
}

#creation-modal .modal-header .modal-title {
  width: 100%;
  font-weight: 700;
  text-align: center;
  color: var(--white);
}

#creation-modal .modal-header button {
  display: none;
}

.creation-modal-body {
  width: 100%;
}

.creation-modal-txt {
  text-align: center;
  color: var(--white);
}

#creation-modal .modal-footer {
  border: none;
  justify-content: center;
}

.creation-modal-normal-btn {
  all: unset;
  cursor: pointer;
  width: 150px;
  height: 48px;
  border-radius: 15px;
  color: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: color 0.3s ease-in-out;
}

.creation-modal-normal-btn:hover {
  color: var(--hover-white);
}

.creation-modal-grad-btn {
  all: unset;
  cursor: pointer;
  width: 150px;
  height: 48px;
  padding: 2px;
  background-image: var(--grad-color-2);
  border-radius: 15px;
}

.creation-modal-grad-btn span {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--black);
  color: var(--white);
  border-radius: 13px;
  transition: background 0.3s ease-in-out;
}

.creation-modal-grad-btn:hover span {
  background-color: transparent;
}
</style>
